import { queriesAcknowledgements } from "@query";
import { updateAcknowledgement } from "../../../services/api/onboarding/acknowledgements";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";

// Still on v1: v3 only exposes acceptAcknowledgement (always sets `Given`),
// so consumers that record an explicit `NotGiven` (opt-out of e-delivery) have
// no v3 equivalent yet. Given-only writes go through
// queriesAcknowledgements.acceptAcknowledgement instead.
export const useMutationUpdateAcknowledgement = () =>
  useWSMutation<
    Awaited<ReturnType<typeof updateAcknowledgement>>,
    WSServiceError,
    {
      acknowledgementName: Parameters<typeof updateAcknowledgement>[0];
      requestData: Parameters<typeof updateAcknowledgement>[1];
    }
  >(
    ({ acknowledgementName, requestData }) =>
      updateAcknowledgement(acknowledgementName, requestData),
    {
      // Acknowledgement reads live on v3 — invalidate the registry key.
      dependencies: [queriesAcknowledgements.getAcknowledgement.queryKeyBase]
    }
  );
